import useImage from "use-image";
// import { GRID_SIZE, TEXT_PROPS, useApiaryScheme } from "../lib/useApiaryScheme"
import { 
  // ApiarySchemeControls, 
  // ApiarySchemeSizeButton, 
  // ApiarySchemeSizes, 
  // ApiarySchemeWrapper,
  ApiarySchemeInfoButton,
  ApiarySchemeInfoModal,
  ApiarySchemeInfoTitle,
  ApiarySchemeInfoLegend,
  ApiarySchemeInfoLegendItem,
  ApiarySchemeInfoLegendIcon,
  ApiarySchemeInfoLegendText,
  ApiarySchemeInfoHeader,
  ApiarySchemeInfoCloseButton,
} from "./styles"
// import { Stage, Layer, Text, Image, Group } from 'react-konva';
// import { FC } from "react";
// import Button from '@atomaro/ui-kit/components/Button/Button/Button';
// import { Spacer } from "shared/ui/spacer";
// import { toRem } from "shared/helpers";
// import { COLORS } from "shared/consts";
import { InformationIcon } from "shared/ui/icons/notificationIcons/informationIcon";
import { CloseIcon } from "shared/ui/icons";
import {GRID_SIZE, TEXT_PROPS, useApiaryScheme} from "../lib/useApiaryScheme"
import {
  ApiarySchemeControls,
  ApiarySchemeSizeButton,
  ApiarySchemeSizes,
  ApiarySchemeWrapper,
  ApiarySchemeEditButtons,
  ApiarySchemeEmptyState,
  ApiarySchemeEmptyTitle,
  ApiarySchemeEmptyDescription,
  ApiarySchemeEmptyControls
} from "./styles"
import {Group, Image, Layer, Stage, Text} from 'react-konva';
import {FC} from "react";
import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import { Spacer } from "shared/ui/spacer";
import { toRem } from "shared/helpers";
import { COLORS } from "shared/consts";
import { useHivesStore } from "entities/hives";
import { AddLarge } from "shared/ui/icons";

import schemeHiveWithDevices from 'shared/assets/img/scheme_hive_with_devices.svg'
import schemeHiveWithoutDevices from 'shared/assets/img/scheme_hive_without_devices.svg'
import schemeHiveWithDevicesDark from 'shared/assets/img/scheme_hive_with_devices_dark.svg'
import schemeHiveWithoutDevicesDark from 'shared/assets/img/scheme_hive_without_devices_dark.svg'
import { ApiarySchemeModal } from "./ApiarySchemeModal";
import { SubmitModal } from "widgets/SubmitModal";

type URLImageProps = {
  src: string;
  [x: string]: any;
}
const URLImage: FC<URLImageProps> = ({ src, ...rest }) => {
  const [image] = useImage(src, 'anonymous');
  return <Image image={image} {...rest} />;
};

export const ApiaryScheme = () => {
  const {
    canvasRef,
    wrapperRef,
    stageSizes,
    layerRef,
    isEditMode,
    hiveSchemeItems,
    currentTheme,
    activeSchemeItem,
    activeSchemeItemCoords,
    isActiveSchemeItemOpen,
    isCancelModalOpen,
    isInfoModalOpen,
    objectsRef,
    onCanvasWheel,
    drawGrid,
    scaleDown,
    scaleUp,
    onGroupClick,
    onActiveSchemeItemClose,
    onDragEnd,
    onEditModeClick,
    onCancelEdit,
    handleCancelConfirm,
    setIsCancelModalOpen,
    setIsInfoModalOpen,
    hasHives,
    isLoading,
  } = useApiaryScheme();

  const openPopup = useHivesStore((s) => s.managePopup);

  return (
    <ApiarySchemeWrapper ref={wrapperRef}>
      <Stage 
        width={stageSizes.current.width} 
        height={stageSizes.current.height}
        ref={canvasRef}
        draggable
        onWheel={onCanvasWheel}
        onDragMove={drawGrid}
        onDragEnd={drawGrid}
      >
        <Layer ref={layerRef}></Layer>
        {hasHives && (
          <Layer ref={objectsRef}>
            {hiveSchemeItems.map(item => {
            let imageSrc = schemeHiveWithDevices;
            if (item.devicesCount > 0) {
              imageSrc = currentTheme === 'dark' ? schemeHiveWithDevicesDark : schemeHiveWithDevices
            } else {
              imageSrc = currentTheme === 'dark' ? schemeHiveWithoutDevicesDark : schemeHiveWithoutDevices
            }

            let fill = '#FF622D';
            if (item.devicesCount <= 0) {
              fill = currentTheme === 'dark' ? '#B5B7C0' : '#585D69'
            }

            return (
              <Group
                x={item.x}
                y={item.y}
                draggable={isEditMode}
                key={item.id}
                id={item.id}
                width={GRID_SIZE}
                height={GRID_SIZE}
                onClick={(evt) => onGroupClick(evt, item)}
                onTouchStart={(evt) => onGroupClick(evt, item)}
                onDragEnd={(evt) => onDragEnd(evt, item)}
              >
                <Text 
                  text={`№${item.number}`} 
                  x={item.textX}
                  y={item.textY}
                  width={GRID_SIZE}
                  {...TEXT_PROPS}
                  fill={fill}
                />
                <URLImage 
                  src={imageSrc}
                  x={item.x}
                  y={item.y + 24}
                  width={GRID_SIZE}
                  height={GRID_SIZE - 24}
                />
              </Group>
            )
            })}
          </Layer>
        )}
      </Stage>
      <ApiarySchemeEmptyControls>
        <ApiarySchemeSizeButton onClick={scaleUp}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.25 12.75V18H12.75V12.75H18V11.25H12.75V6H11.25V11.25H6V12.75H11.25Z" fill={COLORS.ACCENT.DEFAULT}/>
          </svg>
        </ApiarySchemeSizeButton>
        <ApiarySchemeSizeButton onClick={scaleDown}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M6 11.25H18V12.75H6V11.25Z" fill={COLORS.ACCENT.DEFAULT}/>
          </svg>
        </ApiarySchemeSizeButton>
      </ApiarySchemeEmptyControls>
      {isLoading ? (
        <ApiarySchemeEmptyState>
          <ApiarySchemeEmptyTitle>Данные подгружаются</ApiarySchemeEmptyTitle>
        </ApiarySchemeEmptyState>
      ) : !hasHives ? (
        <ApiarySchemeEmptyState>
          <ApiarySchemeEmptyTitle>Ульи не найдены</ApiarySchemeEmptyTitle>
          <ApiarySchemeEmptyDescription>
            На данной пасеке не зафиксированы активные ульи.
            <br />
            Добавьте свой, чтобы начать формировать базу данных.
          </ApiarySchemeEmptyDescription>
          <Button
            label="Добавить улей"
            onClick={() => openPopup(true)}
            iconPrefix={<AddLarge />}
          />
        </ApiarySchemeEmptyState>
      ) : null}
      {hasHives && (
        <ApiarySchemeControls>
        <Spacer 
          width="0"
          height={toRem(36)}
        />
        <ApiarySchemeSizes>
          <ApiarySchemeSizeButton onClick={scaleUp}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M11.25 12.75V18H12.75V12.75H18V11.25H12.75V6H11.25V11.25H6V12.75H11.25Z" fill={COLORS.ACCENT.DEFAULT}/>
            </svg>
          </ApiarySchemeSizeButton>
          <ApiarySchemeSizeButton onClick={scaleDown}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M6 11.25H18V12.75H6V11.25Z" fill={COLORS.ACCENT.DEFAULT}/>
            </svg>
          </ApiarySchemeSizeButton>
        </ApiarySchemeSizes>
        <ApiarySchemeEditButtons>
          {isEditMode ? (
            <>
              <Button 
                label="Отмена"
                variant="secondary"
                colorScheme="neutral"
                onClick={onCancelEdit}
              />
              <Button 
                label="Сохранить"
                onClick={onEditModeClick}
              />
            </>
          ) : (
            <Button 
              label="Редактировать схему"
              onClick={onEditModeClick}
            />
          )}
        </ApiarySchemeEditButtons>
      </ApiarySchemeControls>
      )}
      {!isInfoModalOpen ? (
        <ApiarySchemeInfoButton onClick={() => setIsInfoModalOpen(true)}>
          <InformationIcon fill={COLORS.FG.DEFAULT} width={24} height={24} />
        </ApiarySchemeInfoButton>
      ) : (
        <ApiarySchemeInfoModal>
          <ApiarySchemeInfoHeader>
            <ApiarySchemeInfoTitle>Обозначение ульев:</ApiarySchemeInfoTitle>
            <ApiarySchemeInfoCloseButton onClick={() => setIsInfoModalOpen(false)}>
              <CloseIcon />
            </ApiarySchemeInfoCloseButton>
          </ApiarySchemeInfoHeader>
          <ApiarySchemeInfoLegend>
            <ApiarySchemeInfoLegendItem>
              <ApiarySchemeInfoLegendIcon>
                <img 
                  src={currentTheme === 'dark' ? schemeHiveWithoutDevicesDark : schemeHiveWithoutDevices} 
                  alt="Улей без устройств"
                />
              </ApiarySchemeInfoLegendIcon>
              <ApiarySchemeInfoLegendText>Нет подключенных устройств</ApiarySchemeInfoLegendText>
            </ApiarySchemeInfoLegendItem>
            <ApiarySchemeInfoLegendItem>
              <ApiarySchemeInfoLegendIcon>
                <img 
                  src={currentTheme === 'dark' ? schemeHiveWithDevicesDark : schemeHiveWithDevices} 
                  alt="Улей с устройствами"
                />
              </ApiarySchemeInfoLegendIcon>
              <ApiarySchemeInfoLegendText>Есть подключенные устройства</ApiarySchemeInfoLegendText>
            </ApiarySchemeInfoLegendItem>
          </ApiarySchemeInfoLegend>
        </ApiarySchemeInfoModal>
      )}
      <ApiarySchemeModal 
        isOpen={isActiveSchemeItemOpen}
        onClose={onActiveSchemeItemClose}
        activeSchemeItem={activeSchemeItem}
        activeSchemeItemCoords={activeSchemeItemCoords}
      />
       <SubmitModal
        isOpen={isCancelModalOpen}
        onClose={() => setIsCancelModalOpen(false)}
        onConfirm={handleCancelConfirm}
        title="Несохраненные изменения"
        subtitle="У вас есть несохраненные изменения. Вы уверены, что хотите отменить редактирование?"
        submitText="Отменить"
        declineText="Продолжить"
      />
    </ApiarySchemeWrapper>
  );  
}